export default "__VITE_ASSET__Du3bF14k__"